import i18next from "i18next";

import { createColumn } from "../../../../../../components/Table";

export const promDetailsTableColumns = [
  createColumn({
    keyName: "total",
    header: () => i18next.t("patientPage_columns_total"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "time",
    header: () => i18next.t("patientPage_columns_time"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "rightSpace",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 1,
  }),
];

export const promQuestionsAndAnswersTableColumns = [
  createColumn({
    keyName: "question",
    header: () => i18next.t("patientPage_columns_question"),
    cell: (info) => info.renderValue(),
    size: 690,
  }),
  createColumn({
    keyName: "answer",
    header: () => i18next.t("patientPage_columns_answer"),
    cell: (info) => info.renderValue(),
    size: 250,
  }),
  createColumn({
    keyName: "rightSpace",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 40,
  }),
];
